var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiesel = function SvgDiesel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeWidth: 1.5,
    d: "M22.406 45V9.868h14.309c6.213 0 11.25 5.037 11.25 11.25V45c0 .69-.56 1.25-1.25 1.25H23.656c-.69 0-1.25-.56-1.25-1.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8CE99A",
    stroke: "#36354C",
    strokeWidth: 1.5,
    d: "M29.188 36.882V17.309h5.779a6.25 6.25 0 0 1 6.25 6.25v13.323c0 .69-.56 1.25-1.25 1.25h-9.53c-.69 0-1.25-.56-1.25-1.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeWidth: 1.5,
    d: "M22.75 2a.25.25 0 0 1 .25-.25h11.815a.25.25 0 0 1 .25.25v5.794c0 .69-.56 1.25-1.25 1.25H24c-.69 0-1.25-.56-1.25-1.25z"
  })));
};
export default SvgDiesel;